import { apiGet, apiPost, apiGetBlob } from "./apiClient";

export async function getBankAccountStatements(bankAccountId, startDate, endDate) {
  const params = new URLSearchParams();
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  const query = params.toString() ? `?${params.toString()}` : "";
  return apiGet(`/bank-statements/bank-account/${bankAccountId}${query}`);
}

export async function getBankAccountReportStatements(bankAccountId, startDate, endDate) {
  const params = new URLSearchParams();
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  const query = params.toString() ? `?${params.toString()}` : "";
  return apiGet(`/bank-report/bank-account/${bankAccountId}${query}`);
}

export function getScrapLogs() {
  return apiGet(`/scraper/logs`);
}

export function startScraping(hours) {
  return apiPost(`/scraper/start?hours=${hours}`);
}

export async function downloadBankStatementExcel(
  bankAccountId,
  bank,
  startDate,
  endDate,
) {
  const params = new URLSearchParams();
  params.append("bank", bank);

  if (startDate) {
    params.append("startDate", startDate);
  }

  if (endDate) {
    params.append("endDate", endDate);
  }

  const response = await apiGetBlob(
    `/bank-statements/export/${bankAccountId}?${params.toString()}`,
  );

  return {
    blob: response.blob,
    contentDisposition: response.headers?.get?.("content-disposition") ?? null,
  };
}

export async function downloadBankReportStatementExcel(
  bankAccountId,
  bank,
  startDate,
  endDate,
) {
  const params = new URLSearchParams();
  params.append("bank", bank);

  if (startDate) {
    params.append("startDate", startDate);
  }

  if (endDate) {
    params.append("endDate", endDate);
  }

  const response = await apiGetBlob(
    `/bank-report/export/${bankAccountId}?${params.toString()}`,
  );

  return {
    blob: response.blob,
    contentDisposition: response.headers?.get?.("content-disposition") ?? null,
  };
}
